import { Ng2StateDeclaration } from '@uirouter/angular';

export const notFoundState: Ng2StateDeclaration = {
  name: 'not-found',
  url: '/not-found',
  loadComponent: () => import('./containers/not-found.component').then(m => m.NotFoundComponent),
  data: {
    bodyClass: 'app-white'
  }
};
